<template>
	<div class="quad__block__child big__text">
		<h4 v-if="title" v-html="title"></h4>
		<h1 v-if="text" v-html="text"></h1>
		<a v-if="link" :href="link" v-html="link_label"></a>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		title: {},
		text: {},
		link: {},
		link_label: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.big__text {
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;

	h1 {
		color: white;
		width: 70%;
		font-size: 3rem;

		@media (max-width: 1366px) {
			width: 100%;
			font-size: 2rem;
		}

		@media (max-width: 900px) {
			font-size: 1.5rem;
		}
	}

	a {
		color: $edc-red;
		text-decoration: none;
		font-weight: bold;
		transition: 0.2s ease all;
		font-size: 3rem;

		@media (max-width: 1366px) {
			font-size: 2rem;
		}

		@media (max-width: 900px) {
			font-size: 1.5rem;
		}

		&:hover {
			text-decoration: underline;
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/BigText.vue